import { useMemo } from 'react';
import {
  addMediaFinished,
  addMediaStarted,
  addMediaUploadingCompleted,
  addMediaWaitingCompleted,
} from '@wix/bi-logger-media-manager-g6/v2';

import { bi } from '../../../services/loggers/bi';

export const useTrackAddMediaUploadProcessAnalytics = () =>
  useMemo(
    () => ({
      trackAddMediaStarted: (params) => bi.logger().report(addMediaStarted(params)),
      trackAddMediaFinished: (params) => bi.logger().report(addMediaFinished(params)),
      trackAddMediaWaitingCompleted: (params) => bi.logger().report(addMediaWaitingCompleted(params)),
      trackAddMediaUploadingCompleted: (params) => bi.logger().report(addMediaUploadingCompleted(params)),
    }),
    [],
  );
